import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import Carousel from "./carousel"
import "./location-section-v2.scss"
import SearchInput from "./searchInput"

const LocationSectionV2 = ({ ctaButton, featuredClinics, heading, text }) => {
  return (
    <section className="location-section-v2">
      <div className="container-v2">
        <div className="location-section-v2--first-section">
          <div className="location-section-v2--first-section-content">
            {heading && (
              <h2>
                <TextLockupV2>{heading}</TextLockupV2>
              </h2>
            )}

            <div className="location-section-v2--location-search-form">
              <SearchInput />
            </div>
          </div>
          {text?.text && <p>{text.text}</p>}
        </div>
        <div className="location-section-v2--second-section">
          <Carousel featuredLocations={featuredClinics} />
          {ctaButton && ctaButton.path && ctaButton.text && (
            <p className="location-section-v2--second-section-cta">
              <ButtonV2
                accessibilityLabel={ctaButton.accessibilityLabel}
                className={getButtonClasses(
                  ctaButton.buttonStyle || "primary-green",
                  ctaButton.buttonSize || "large"
                )}
                href={ctaButton.path}
                key={ctaButton.id}
                showArrow={ctaButton.showArrow === "Yes" ? true : false}
                text={ctaButton.text}
              />
            </p>
          )}
        </div>
      </div>
    </section>
  )
}

LocationSectionV2.propTypes = {
  ctaButton: PropTypes.object.isRequired,
  featuredClinics: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default LocationSectionV2
